@if (data != null && series != null) {
    <app-pg-chart [createChart]="createChart"></app-pg-chart>
}
